import * as actions from '../../actions/task/taskActions'

export const initialState = {
    tasks: [],
    loading: false,
    hasErrors: false,
    errorTaskCreationToaster: false,
}

export default function tasksReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_TASKS:
            return { ...state, loading: true }
        case actions.GET_TASKS_SUCCESS:
            return { tasks: action.payload, loading: false, hasErrors: false }
        case actions.GET_TASKS_FAILURE:
            return { ...state, loading: false, hasErrors: true }

        // Add Task
        // case actions.ADD_TASK:
        //     return { loading: false, hasErrors: false }
        case actions.ADD_TASK_FAILURE:
            return { ...state, loading: false,errorTaskCreationToaster: true }
        default:
            return state
    }
}